import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../index-e71f83b5.js";
import { COMMON_CLASSNAME } from "../../constants.js";
import "../../../_commonjsHelpers-0c53d963.js";
function FlashNamespaced(props) {
  return /* @__PURE__ */ jsx("div", { className: classNames(COMMON_CLASSNAME, props.className), children: props.children });
}
export {
  FlashNamespaced as default
};
//# sourceMappingURL=FlashNamespaced.js.map
